<template>
  <div id="cc-product-listing-panel" class="py-4 px-3">
    <h3>Product Listing</h3>
    <BranchDropdown />
    <hr class="divider">
    <ProductFilter />
    <ProductCategoriesDropdown />
    <hr class="divider">
    <ProductListingComponent ref="productListingComponent" />
  </div>
</template>

<script>
import BranchDropdown from "./BranchDropdown";
import ProductFilter from "./ProductFilterPanel";
import ProductCategoriesDropdown from "./ProductCategoriesDropdown";
import ProductListingComponent from "./ProductListingComponent";

export default {
  components: { BranchDropdown, ProductFilter, ProductCategoriesDropdown, ProductListingComponent }
}
</script>

<style lang="scss" scoped>
h3 {
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #2F3941;
}
hr.divider {
  margin: 1.5rem -1rem;
}
</style>
